import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";

//components:
import {BasicNetgraph} from "../../widgets/";
import {CircularProgress} from "@material-ui/core";
import {BlurOn, Info} from "@material-ui/icons";

import {processNetgraphData} from "./processNetgraphData";

export const NetgraphWrapper = ({
	data: rawData,
	features: featuresTypes = [],
	config: customConfig = {},
	aspectRatio = 16 / 9,
	nodeSelectionCallback = () => {},
	nodeUnselectionCallback = () => {},
	selectedNodeName,
	isLoading,
	onEmptyShowIcon = false,
	showMasterNodesLabels = true,
}) => {
	const [graphData, setGraphData] = useState({nodes: []});

	const {t} = useTranslation();

	useEffect(() => {
		if (rawData?.length) {
			let selectedData = [];
			for (let i = 0; i < rawData.length; i++) {
				const rawSpeaker = rawData[i];
				const rawFeatures = rawSpeaker?.features;
				const speaker = Object.assign({}, rawSpeaker);
				speaker.features = [];
				if (typeof featuresTypes === 'string') featuresTypes = [featuresTypes]
				featuresTypes.forEach(key => {
					if (key in rawFeatures) {
						speaker.features = speaker.features.concat(rawFeatures[key]);
					}
				});
				selectedData.push(speaker);
			}
			if (selectedData?.length) {
				const data = processNetgraphData(selectedData);
				setGraphData(data);
			} else {
				setGraphData({nodes: []});
			}
		}
	}, [rawData, featuresTypes]);

	useEffect(() => {
		if (customConfig?.textSettings) customConfig.textSettings.showMasterNodesLabels = showMasterNodesLabels;
	}, [customConfig, showMasterNodesLabels]);

	if (isLoading) {
		return (
			<div className="d-flex justify-content-center align-items-center position-absolute top-0 left-0 w-100 h-100">
				<CircularProgress />
			</div>
		);
	}
	if (graphData && graphData.nodes && graphData.nodes.length === 0) {
		if (!onEmptyShowIcon) {
			return (
				<div className="netgraph_empty_message">
					<div className="icon_container">
						<Info color="secondary" />
					</div>
					<div className="ml-4 d-flex justify-content-center flex-column">
						<h3>{t("NETGRAPH.EMPTY.TITLE")}</h3>
						<h4 className="text-muted">{t("NETGRAPH.EMPTY.SUBTITLE")}</h4>
					</div>
				</div>
			);
		} else {
			return (
				<div className="d-flex h-100 w-100 align-items-center justify-content-center p-5">
					<BlurOn className="text-muted h-100 w-100 max-w-200" />
				</div>
			);
		}
	} else {
		return (
			<BasicNetgraph
				config={customConfig}
				data={graphData}
				aspectRatio={aspectRatio}
				nodeSelectionCallback={nodeSelectionCallback}
				nodeUnselectionCallback={nodeUnselectionCallback}
				selectedNodeName={selectedNodeName}
			/>
		);
	}
};

NetgraphWrapper.propTypes = {
	data: PropTypes.arrayOf(PropTypes.object),
	feature: PropTypes.string,
	config: PropTypes.object,
	showMasterNodesLabels: PropTypes.bool,
	aspectRatio: PropTypes.number,
	nodeSelectionCallback: PropTypes.func,
	nodeUnselectionCallback: PropTypes.func,
	selectedNodeName: PropTypes.string,
};
